import ClubFinderDropdown from "./ClubFinderDropdown";
import PackageJson from "../../package.json";
function ClubFinder(props) {
  const lang = props.lang;

  let items = props.data.items;
  items = items.sort((a, b) => {
    if (a.name[lang] > b.name[lang]) {
      return 1;
    }
    if (b.name[lang] > a.name[lang]) {
      return -1;
    }
    return 0;
  });
  items = items.map((studio, index) => {
    return { id: index, name: studio.name[lang], url: studio.url[lang] };
  });
  return (
  <div className="tw-bg-gray-light tw-p-5 tw-rounded-lg">
    <h2 className="tw-tracking-tight tw-font-italic tw-text-3xl tw-uppercase xmd:tw-leading-3 xmd:tw-leading-3 tw-text-center tw-mt-4 tw-mb-4">
      {props.data.searchLabel[lang]}
    </h2>   
    <p className="tw-text-center tw-mb-8 tw-leading-5">{props.data.searchLabelDescription[lang]}</p>
    <div 
        className="tw-h-36 lg:tw-h-56 tw-rounded-lg lg:tw-rounded-2xl tw-bg-gray-medium tw-flex tw-flex-col tw-items-center tw-justify-center tw-bg-center tw-bg-cover tw-px-6 lg:tw-mt-2"
        style={{
          backgroundImage: 'url("'+PackageJson.homepage+'images/map.png")',
        }}
      >
        <ClubFinderDropdown
          items={items}
          placeholder={props.data.searchLabel[lang]}
          link={props.data.studiosLink[lang]}
        />
      </div>
      </div>
  );
}

export default ClubFinder;
